import { Flex, Heading, Text } from '@chakra-ui/react';

export default function CardTitle({ title, subtitle = null, padding = null, headingLevel = null }) {
  return (
    <Flex direction="column" padding={padding ? padding : '0'}>
      <Heading
        as={headingLevel ? headingLevel : 'h3'}
        variant="h3"
        textAlign="center"
      >
        {title}
      </Heading>
      {subtitle && <Text textAlign="center">{subtitle}</Text>}
    </Flex>
  );
}
